import { takeLatest, call, all, put } from "redux-saga/effects";
import { getStatus } from "services/Status/sagas";
import { getStatusType } from "services/StatusType/sagas";
import { getSource } from "services/Source/sagas";
import { getReceiverWorker } from "services/Receiver/sagas";
import { getBranchesWorker } from "services/Branch/sagas";
import { getBrandsWorker } from "services/Brand/sagas";
import { getUsersWorker } from "services/Users/sagas";
import { initTrackerModuleAction, initTrackerModuleLoading } from "modules/Tracker/services/initialization/actions";

function* activeModuleWorker (){
    yield put(initTrackerModuleLoading(true));

    yield all([
        call(getBranchesWorker),
        call(getBrandsWorker),
        call(getUsersWorker),
        call(getStatus),
        call(getStatusType),
        call(getSource),
        call(getReceiverWorker)
    ]);

    yield put(initTrackerModuleLoading(false));
}

export function* initTracker() {
    yield all([
        yield takeLatest(initTrackerModuleAction, activeModuleWorker)
    ]);
}
